// extracted by mini-css-extract-plugin
export default {"content":"style_content__US+v9","checkbox":"style_checkbox__IT88x"};